import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BookOpenIcon } from 'lucide-react';
type Volume = {
  number: string;
  title: string;
  description: string;
  accent: string;
  icon: string;
};
const volumes: Volume[] = [{
  number: '01',
  title: 'Class Foundations',
  description: 'Build safe, balanced, confident sessions from the ground up.',
  accent: 'bg-navy',
  icon: 'text-navy'
}, {
  number: '02',
  title: 'Ready-to-Teach Classes',
  description: 'Use practical class structures you can open and teach.',
  accent: 'bg-spine-teal',
  icon: 'text-spine-teal'
}, {
  number: '03',
  title: 'Choreography Library',
  description: 'Keep combinations fresh, clear, and easy to follow.',
  accent: 'bg-spine-lime',
  icon: 'text-spine-lime'
}, {
  number: '04',
  title: 'Dance Cardio System',
  description: 'Create energizing cardio flows with the right intensity.',
  accent: 'bg-spine-orange',
  icon: 'text-spine-orange'
}, {
  number: '05',
  title: 'Themed Classes',
  description: 'Make every month feel new with memorable concepts.',
  accent: 'bg-spine-red',
  icon: 'text-spine-red'
}, {
  number: '06',
  title: 'Annual Planning',
  description: 'Organize weeks and seasons without Sunday-night stress.',
  accent: 'bg-violet',
  icon: 'text-violet'
}, {
  number: '07',
  title: 'Instructor Success',
  description: 'Lead with stronger cueing, confidence, and presence.',
  accent: 'bg-spine-purple',
  icon: 'text-spine-purple'
}];
export function ClassLibrary() {
  return <section className="bg-cloud px-4 py-20 sm:py-24" data-id="element-35">
      <div className="mx-auto max-w-6xl" data-id="element-36">
        <header className="mx-auto max-w-3xl text-center" data-id="element-37">
          <p className="headline-kicker text-xs font-bold text-violet" data-id="element-38">
            THE 7-VOLUME SYSTEM
          </p>
          <h2 className="mt-3 font-display text-3xl font-black uppercase text-navy sm:text-5xl" data-id="element-39">
            Everything you need to{' '}
            <span className="text-violet" data-id="element-40">plan, teach, and grow.</span>
          </h2>
          <p className="mt-4 text-slate-600" data-id="element-41">
            Seven connected resources that make class delivery simpler,
            stronger, and more professional.
          </p>
        </header>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-42">
          {volumes.map((volume, index) => <motion.article key={volume.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          ease: [0.22, 1, 0.36, 1]
        }} className="overflow-hidden rounded-2xl border border-line bg-white shadow-sm" data-id="element-43">
              <div className={`h-2 ${volume.accent}`} data-id="element-44" />
              <div className="p-6" data-id="element-45">
                <div className="flex items-start justify-between" data-id="element-46">
                  <span className="font-display text-3xl font-black text-slate-200" data-id="element-47">
                    {volume.number}
                  </span>
                  <BookOpenIcon size={20} className={volume.icon} data-id="element-48" />
                </div>
                <h3 className="mt-4 font-display text-xl font-extrabold uppercase text-navy" data-id="element-49">
                  {volume.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-50">
                  {volume.description}
                </p>
                <p className={`mt-5 flex items-center gap-1 text-xs font-bold uppercase tracking-wide ${volume.icon}`} data-id="element-51">
                  Explore volume <ArrowRightIcon size={14} data-id="element-52" />
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}